import { AnnotationView, PredictionType } from "@/entities/annotation";
import {
  ANNOTATION_TYPES,
  PREDICTION_TYPES,
} from "@/entities/annotation/model/consts";
import JourneyEventDetails from "../journey/journey-event-details";
import TransactionEventDetails from "../transaction/transaction-event-details";
import TrackPersistenceEventDetails from "../track-persistence/track-persistence-event-details";
import ProximityEventDetails from "../proximity/proximity-event-details";
import PinBasedPredictionDetails from "../pin-based-prediction/pin-based-prediction-details";
import ZoneBasedPredictionDetails from "../zone-based-prediction/zone-based-prediction-details";
import ProximityTimeRangeEventDetails from "../proximity-time-range/proximity-time-range-event-details";

type EventType = AnnotationView | PredictionType;

const eventDetails: Record<EventType, React.FC> = {
  [ANNOTATION_TYPES.JOURNEY]: JourneyEventDetails,
  [ANNOTATION_TYPES.TRANSACTION]: TransactionEventDetails,
  [ANNOTATION_TYPES.TRACK_PERSISTENCE]: TrackPersistenceEventDetails,
  [ANNOTATION_TYPES.PROXIMITY]: ProximityEventDetails,
  [ANNOTATION_TYPES.PROXIMITY_TIME_RANGES]: ProximityTimeRangeEventDetails,
  [PREDICTION_TYPES.PIN]: PinBasedPredictionDetails,
  [PREDICTION_TYPES.ZONE]: ZoneBasedPredictionDetails,
};

export const getEventDetails = (type: EventType) => {
  return eventDetails[type];
};
